/**
 * OW Plinko v3 — Smooth physics, pin glow, ball sinks into slots
 */
(function(){
'use strict';

var ROWS = 9;
var GRAVITY = 0.15;
var BOUNCE = 0.4;
var FRICTION = 0.995;
var PIN_R = 4;
var BALL_R = 8;
var slots = [10,15,20,25,20,15,10];
var slotWeights = [3,10,25,62,25,10,3];

var canvas, ctx, W, H, dpr;
var pins = [], glowPins = [], slotBounds = [];
var ball = null, animId = null, settled = false, playing = false;
var pinSpaceX, pinSpaceY, boardTop, slotY;

function init() {
  canvas = document.getElementById('plinko-canvas');
  if (!canvas) return;
  ctx = canvas.getContext('2d');
  dpr = Math.min(window.devicePixelRatio || 1, 2);
  resize();
  render();
  window.addEventListener('resize', function(){ resize(); render(); });
  document.getElementById('plinko-play').addEventListener('click', drop);
  document.getElementById('plinko-retry').addEventListener('click', reset);
  var overlay = document.getElementById('plinko-overlay');
  overlay.addEventListener('click', function(e){ if (e.target === overlay) reset(); });
}

function resize() {
  var wrap = canvas.parentElement;
  W = Math.min(wrap.clientWidth, 360);
  var isMobile = window.innerWidth < 600;
  H = Math.round(W * (isMobile ? 1.2 : 1.35));
  canvas.width = W * dpr; canvas.height = H * dpr;
  canvas.style.width = W + 'px'; canvas.style.height = H + 'px';
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

  boardTop = isMobile ? 10 : 25;
  slotY = H - 30;
  pinSpaceY = (slotY - boardTop - 20) / ROWS;
  pinSpaceX = (W - 40) / (ROWS + 2);

  pins = [];
  for (var r = 0; r < ROWS; r++) {
    var count = r + 3;
    var rowW = (count - 1) * pinSpaceX;
    var sx = (W - rowW) / 2;
    for (var c = 0; c < count; c++) {
      pins.push({ x: sx + c * pinSpaceX, y: boardTop + (r + 1) * pinSpaceY, glow: 0 });
    }
  }

  var slotW = W / slots.length;
  slotBounds = [];
  for (var i = 0; i < slots.length; i++) {
    slotBounds.push({ x: i * slotW, w: slotW, cx: i * slotW + slotW / 2 });
  }
  updateSlotElements();
}

function updateSlotElements() {
  var el = document.getElementById('plinko-slots');
  if (!el) return;
  el.style.maxWidth = W + 'px';
}

function render() {
  ctx.clearRect(0, 0, W, H);

  pins.forEach(function(p) {
    if (p.glow > 0) {
      ctx.beginPath(); ctx.arc(p.x, p.y, PIN_R + 8, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(0,140,255,' + (p.glow * 0.35) + ')';
      ctx.fill();
      p.glow = Math.max(0, p.glow - 0.03);
    }
    ctx.beginPath(); ctx.arc(p.x, p.y, PIN_R, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(255,255,255,' + (0.3 + (p.glow * 0.5)) + ')';
    ctx.fill();
  });

  var slotW = W / slots.length;
  for (var i = 0; i < slots.length; i++) {
    var sx = i * slotW;
    if (i > 0) {
      ctx.beginPath();
      ctx.moveTo(sx, slotY - 12);
      ctx.lineTo(sx, slotY + 15);
      ctx.strokeStyle = 'rgba(255,255,255,0.15)';
      ctx.lineWidth = 1;
      ctx.stroke();
    }
  }

  if (ball) drawBall();
}

function drawBall() {
  ctx.save();
  var g = ctx.createRadialGradient(ball.x - 2, ball.y - 2, 1, ball.x, ball.y, BALL_R);
  g.addColorStop(0, '#ffffff');
  g.addColorStop(0.4, '#aaddff');
  g.addColorStop(0.8, '#0077cc');
  g.addColorStop(1, '#003366');
  ctx.beginPath(); ctx.arc(ball.x, ball.y, BALL_R, 0, Math.PI * 2);
  ctx.fillStyle = g; ctx.fill();
  ctx.shadowColor = 'rgba(0,140,255,0.5)'; ctx.shadowBlur = 10;
  ctx.beginPath(); ctx.arc(ball.x, ball.y, BALL_R, 0, Math.PI * 2);
  ctx.strokeStyle = 'rgba(255,255,255,0.6)'; ctx.lineWidth = 0.8; ctx.stroke();
  ctx.restore();
}

function pickSlot() {
  var total = 0; slotWeights.forEach(function(w){ total += w; });
  var r = Math.random() * total, acc = 0;
  for (var i = 0; i < slotWeights.length; i++) { acc += slotWeights[i]; if (r <= acc) return i; }
  return 3;
}

function drop() {
  if (playing) return;
  playing = true; settled = false;
  var btn = document.getElementById('plinko-play');
  btn.disabled = true; btn.textContent = 'Playing...';
  var retry = document.getElementById('plinko-retry');
  retry.classList.remove('is-visible');

  var startX = W / 2 + (Math.random() - 0.5) * pinSpaceX * 0.3;
  ball = { x: startX, y: 8, vx: (Math.random() - 0.5) * 0.3, vy: 0 };
  if (animId) cancelAnimationFrame(animId);
  loop();
}

function loop() {
  if (settled) return;

  ball.vy += GRAVITY;
  ball.vx *= FRICTION;
  ball.vy *= FRICTION;
  ball.x += ball.vx;
  ball.y += ball.vy;

  for (var i = 0; i < pins.length; i++) {
    var p = pins[i];
    var dx = ball.x - p.x, dy = ball.y - p.y;
    var distSq = dx * dx + dy * dy;
    var minD = PIN_R + BALL_R;
    if (distSq < minD * minD && distSq > 0) {
      var dist = Math.sqrt(distSq);
      var nx = dx / dist, ny = dy / dist;
      var overlap = minD - dist;
      ball.x += nx * overlap; ball.y += ny * overlap;
      var dot = ball.vx * nx + ball.vy * ny;
      ball.vx -= (1 + BOUNCE) * dot * nx;
      ball.vy -= (1 + BOUNCE) * dot * ny;
      ball.vx += (Math.random() - 0.5) * 0.6;
      p.glow = 1;
    }
  }

  if (ball.x < BALL_R + 2) { ball.x = BALL_R + 2; ball.vx = Math.abs(ball.vx) * BOUNCE; }
  if (ball.x > W - BALL_R - 2) { ball.x = W - BALL_R - 2; ball.vx = -Math.abs(ball.vx) * BOUNCE; }

  if (ball.y >= slotY) {
    ball.vy *= 0.3;
    ball.vx *= 0.7;

    var si = Math.floor(ball.x / (W / slots.length));
    si = Math.max(0, Math.min(slots.length - 1, si));
    var targetX = slotBounds[si].cx;
    ball.x += (targetX - ball.x) * 0.15;

    if (ball.y > slotY + 5) ball.y = slotY + 5;

    if (Math.abs(ball.vy) < 0.3 && Math.abs(ball.vx) < 0.3 && Math.abs(ball.x - targetX) < 3) {
      ball.x = targetX; ball.y = slotY + 3;
      settled = true;
      render();
      onLand(si);
      return;
    }
  }

  render();
  animId = requestAnimationFrame(loop);
}

function onLand(idx) {
  var pct = slots[idx];
  highlightSlot(idx);
  setTimeout(fireConfetti, 400);
  setTimeout(function(){ showResult(pct); }, 1000);
}

function highlightSlot(idx) {
  var el = document.querySelectorAll('.plinko-slot');
  if (el[idx]) {
    el[idx].style.transform = 'scale(1.1)';
    el[idx].style.boxShadow = '0 0 15px rgba(0,140,255,0.6)';
    setTimeout(function(){
      el[idx].style.transform = ''; el[idx].style.boxShadow = '';
    }, 1500);
  }
}

function reset() {
  var overlay = document.getElementById('plinko-overlay');
  overlay.classList.remove('is-active');
  ball = null; playing = false; settled = false;
  var btn = document.getElementById('plinko-play');
  btn.disabled = false; btn.textContent = btn.dataset.label || 'Jetzt spielen!';
  var retry = document.getElementById('plinko-retry');
  retry.classList.remove('is-visible');
  render();
}

function showResult(pct) {
  document.getElementById('plinko-result-pct').textContent = pct + '%';
  var coupons = window.__plinko_coupons || {};
  var code = coupons[String(pct)] || '';
  var codeEl = document.getElementById('plinko-result-code');
  var linkEl = document.getElementById('plinko-result-link');
  if (codeEl) codeEl.textContent = code ? 'Code: ' + code : '';
  if (linkEl) linkEl.href = code ? '/discount/' + encodeURIComponent(code) + '?redirect=/' : '/';
  document.getElementById('plinko-overlay').classList.add('is-active');
}

function fireConfetti() {
  var c = document.getElementById('plinko-confetti');
  if (!c) return;
  var cctx = c.getContext('2d');
  var vw = window.innerWidth, vh = window.innerHeight;
  c.width = vw * 2; c.height = vh * 2;
  c.style.width = vw + 'px'; c.style.height = vh + 'px';
  cctx.setTransform(2, 0, 0, 2, 0, 0);
  var parts = [], colors = ['#008cff','#005fa3','#fffd76','#fff','#00c2ff','#66ddff','#ff6b6b','#ffd93d'];
  for (var i = 0; i < 140; i++) {
    parts.push({
      x: vw/2 + (Math.random()-.5)*100, y: vh*0.55,
      vx: (Math.random()-.5)*12, vy: -(Math.random()*10+6),
      w: Math.random()*8+3, h: Math.random()*5+2,
      c: colors[Math.floor(Math.random()*colors.length)],
      r: Math.random()*360, rv: (Math.random()-.5)*16, life: 1
    });
  }
  (function tick(){
    cctx.clearRect(0,0,vw,vh); var alive=false;
    parts.forEach(function(p){
      p.vy+=0.28; p.x+=p.vx; p.y+=p.vy; p.r+=p.rv; p.life-=0.008;
      if(p.life<=0)return; alive=true;
      cctx.save(); cctx.translate(p.x,p.y); cctx.rotate(p.r*Math.PI/180);
      cctx.globalAlpha=Math.max(0,p.life); cctx.fillStyle=p.c;
      cctx.fillRect(-p.w/2,-p.h/2,p.w,p.h); cctx.restore();
    });
    if(alive)requestAnimationFrame(tick);else cctx.clearRect(0,0,vw,vh);
  })();
}

document.addEventListener('DOMContentLoaded', init);
})();
